export default __webpack_public_path__ + "static/media/aboutIsa-04.48765b7f.jpg";